export const generateUrl = <T extends Record<string, string | number>>(route: string, params: T): string => {
  return Object.entries(params).reduce((url, [key, value]) => url.replace(`:${key}`, String(value)), route);
};
